import moment from "moment"
// import jwt_decode from "jwt-decode"
import { Link } from 'react-router-dom'
// ** Checks if an object is empty (returns boolean)
export const isObjEmpty = obj => Object.keys(obj).length === 0
import { b64Decode, cookies, gima } from "gima-common"
import color from "material-ui-core/colors/amber"

// ** Returns K format from a number
export const kFormatter = num => (num > 999 ? `${(num / 1000).toFixed(1)}k` : num)

// ** Converts HTML to string
export const htmlToString = html => html.replace(/<\/?[^>]+(>|$)/g, '')

// ** Checks if the passed date is today
const isToday = date => {
  const today = new Date()
  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  )
}

/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (value, formatting = { month: 'short', day: 'numeric', year: 'numeric' }) => {
  if (!value) return value
  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

// ** Returns short month of passed date
export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
  const date = new Date(value)
  let formatting = { month: 'short', day: 'numeric' }

  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: 'numeric', minute: 'numeric' }
  }

  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

export const siteModeisPRD = !window.location.href.includes("localhost")

/**
 ** Return if user is logged in
 ** This is completely up to you and how you want to store the token in your frontend application
 *  ? e.g. If you are using cookies to store the application please update this function
 */
export const isUserLoggedIn = () => gima.getToken()

export const loginToken = () => {
  return siteModeisPRD ? cookies.get("Token") ? cookies.get("Token") : gima.getUserData("jwtToken") : gima.getUserData("jwtToken")
}
export const getUserData = () => { return siteModeisPRD ? cookies.get("Token") ? gima.getTokenInfo() : gima.getTokenInfo() : gima.getTokenInfo() }

// ** React Select Theme Colors
export const selectThemeColors = theme => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: '#7367f01a', // for option hover bg-color
    primary: '#7367f0', // for selected option bg-color
    neutral10: '#7367f0', // for tags bg-color
    neutral20: '#ededed', // for input border-color
    neutral30: '#ededed' // for input hover border-color
  }
})

export const updateLastActionTime = () => {
  const currentDate = moment().utc().format("YYYY-MM-DD HH:mm:ss")
  cookies.set("last_action_time", currentDate)
}

export const inIframe = () => {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}

export const isEmpty = (value) => {
  return (
    value === undefined ||
    value === null ||
    (typeof value === "object" && Object.keys(value).length === 0) ||
    (typeof value === "string" && value.trim().length === 0)
  )
}

export const calculateTimeAgo = (dateTimeString) => {
  const commentTime = moment(dateTimeString, 'YYYY-MM-DD hh:mm A')
  const now = moment()
  const timeDifference = now.diff(commentTime, 'seconds')

  if (timeDifference < 60) {
    return 'Just now'
  } else if (timeDifference < 3600) {
    return `${Math.floor(timeDifference / 60)} minute(s) ago`
  } else if (timeDifference < 86400) {
    return `${Math.floor(timeDifference / 3600)} hour(s) ago`
  } else if (timeDifference < 2592000) {
    return `${Math.floor(timeDifference / 86400)} day(s) ago`
  } else if (timeDifference < 31536000) {
    return `${Math.floor(timeDifference / 2592000)} month(s) ago`
  } else {
    return `${Math.floor(timeDifference / 31536000)} year(s) ago`
  }
}

// export const calculateDueDate = (item, startDate) => {
//   try {
//     // Get the current date and time    
//     const currentDate = moment(startDate)
//     if (currentDate.isValid()) {
//       // Calculate the duration in hours
//       let durationHours = item?.duration || 0

//       // Calculate full days and remaining hours
//       let fullDays = (durationHours / 8)
//       if (fullDays > 1) {
//         while (fullDays > 0) {
//           currentDate.add(1, "days")
//           // Skip weekends if necessary
//           while (currentDate.day() === 0 || currentDate.day() === 6) {
//             currentDate.add(1, 'days')
//           }
//           fullDays -= 1
//         }

//         durationHours = fullDays - Math.floor(fullDays)
//         durationHours = Math.floor(durationHours)
//       }

//       // Add the duration hours
//       currentDate.add(durationHours, 'hours')

//       // Check if the time is greater than to 8:00:00
//       if (currentDate.hour() > 8) {
//         const remainingHoursForNextDay = currentDate.hour() - 8
//         // Move to the next day and set time to the beginning
//         currentDate.add(1, 'day').startOf('day')
//         // Add the remaining hours to the next day
//         currentDate.add(remainingHoursForNextDay, 'hours')
//       }

//       // Skip weekends if necessary
//       while (currentDate.day() === 0 || currentDate.day() === 6) {
//         currentDate.add(1, 'days')
//       }

//       // Log the future date and time      
//       return currentDate
//     } else {
//       return ""
//     }
//   } catch (error) {
//     console.error("Error occurred:", error)
//     return ""
//   }
// }

//Calculate dueDate when template apply in workflow
export const calculateDueDate = (item, startDate) => {
  try {
    // Get the current date and time 
    const currentDate = moment(startDate)
    if (currentDate.isValid()) {
      for (let i = 0; i < item?.duration || 0; i++) {
        currentDate.add(1, 'days')
        // Skip weekends if necessary
        while (currentDate.day() === 0 || currentDate.day() === 6) {
          currentDate.add(1, 'days')
        }
      }
      // Log the future date and time      
      return currentDate
    } else {
      return ""
    }
  } catch (error) {
    console.error("Error occurred:", error)
    return ""
  }
}

export const getSystemConfig = (key) => {
  if (localStorage.getItem('sys_settings')) {
    const configValues = JSON.parse(localStorage.getItem('sys_settings'))
    const findIt = configValues?.filter((a) => {
      return a?.sys_key === key
    })
    if (findIt.length === 1) {
      return findIt[0]
    } else {
      return false
    }
  }
  return false
}

//return the date formate from localStorage
export const getDateFormat = (lowCase = false) => {
  let checkFormat = getSystemConfig('dateFormat')?.sys_value
  checkFormat = checkFormat ? checkFormat : 'YYYY-MM-DD'
  if (lowCase) {
    checkFormat = checkFormat.replace('YYYY', 'Y')
    checkFormat = checkFormat.replace('DD', 'd')
    checkFormat = checkFormat.replace('MM', 'm')
  }
  return checkFormat
}

/**
 * Recalculates the due dates for workflow items based on their duration and a given start date.
 * The function iterates through parent items and their children, updating their due dates
 * based on the specified duration, while skipping weekends.
 * 
 * @param {Array} workflowItems - An array of workflow items, each containing a duration and dueDate.
 * @param {Date|string} startDate - The starting date from which to calculate due dates.
 * @returns {Array} - The updated array of workflow items with recalculated due dates.
 */
// export const reCalculateWorkflowItemDueDate = (workflowItems, startDate) => {
//   if (!isEmpty(workflowItems) && !isEmpty(moment(startDate).format(getDateFormat()))) {
//     let calculatedDateParent = startDate
//     let calculatedDateChild = startDate
//     workflowItems = workflowItems.map(item => {
//       if (!isEmpty(item.duration)) {
//         item.dueDate = calculateDueDate(item, calculatedDateParent)
//         calculatedDateParent = item.dueDate
//       }
//       if (item?.children?.length > 0) {
//         item.children = item.children.map((child) => {
//           if (!isEmpty(child.duration)) {
//             child.dueDate = calculateDueDate(child, calculatedDateChild)
//             calculatedDateChild = child.dueDate
//           }
//           return child
//         })
//       }
//       return item
//     })
//   }
//   return workflowItems
// }
/**
 * Recalculates the due dates for workflow items based on their duration and a given start date.
 * If an item or its children already have a due date, it is preserved.
 * The function iterates through parent items and their children, updating their due dates
 * based on the specified duration, while skipping weekends.
 * This method called when startDate change so it will be re-calculated only if dueDate is null
 * 
 * @param {Array} workflowItems - An array of workflow items, each containing a duration and dueDate.
 * @param {Date|string} startDate - The starting date from which to calculate due dates.
 * @returns {Array} - The updated array of workflow items with recalculated due dates.
 */

export const reCalculateWorkflowItemDueDateV2 = (workflowItems, startDate) => {
  if (!isEmpty(workflowItems) && !isEmpty(moment(startDate).format(getDateFormat()))) {
    let calculatedDateParent = startDate
    let calculatedDateChild = startDate
    workflowItems = workflowItems.map(item => {
      if (!isEmpty(item.duration)) {
        if (!isEmpty(item.dueDate)) {
          calculatedDateParent = item.dueDate
          item.dueDate = calculateDueDate(item, calculatedDateParent)
          calculatedDateParent = item.dueDate
          return item
        }
      }
      if (item?.children?.length > 0) {
        item.children = item.children.map((child) => {
          if (!isEmpty(child.duration)) {
            if (!isEmpty(child.dueDate)) {
              calculatedDateChild = child.dueDate
              child.dueDate = calculateDueDate(child, calculatedDateChild)
              calculatedDateChild = child.dueDate
              return child
            }
          }
          return child
        })
      }
      return item
    })
  }
  return workflowItems
}

export const renderBackLink = (type, flow) => {
  if (flow === "BUSINESS_TEMPLATE") {
    return <Link style={{ color: gima.getThemeColor() || '#6fc055' }} to={`/template/list?parameter=${queryParam}&jwtToken=${gima.getToken()}`}>{type}</Link>
  } else if (flow === "GIMA_TEMPLATE") {
    return <Link style={{ color: gima.getThemeColor() || '#6fc055' }} to={`/template/list`}>{type}</Link>
  } else if (flow === "GIMA_WORKFLOW") {
    return type
  } else if (flow === "BUSINESS_WORKFLOW") {
    return type
  }
  return ""
}

export const sortWorkflowChildrenForCompletedFirst = (children) => {
  const sortedChildren = [...children].sort((a, b) => {

    const isFinished = (item) => {
      const isSkip = (item.status === 'skip' || !!item.skipDate)
      return item?.isCompleted || isSkip
    }

    const getGroupPriority = (status) => {
      if (status === 'completed' || status === 'complete' || status === 'skip') {
        return 0
      }
      return 1 // Everything else (pending, etc.)
    }
    const priorityComparison = getGroupPriority(a.status) - getGroupPriority(b.status)
    if (priorityComparison !== 0) return priorityComparison
    
    // 2. Tertiary Sort: Combined Date (Older at the top)
    const getDateValue = (item) => {
      if (!isFinished(item)) return Infinity
      // This picks the available date regardless of status
      const dateStr = item.completedDate || item.skipDate
      return dateStr ? new Date(dateStr).getTime() : Infinity
    }

    const dateA = getDateValue(a)
    const dateB = getDateValue(b)

    return dateA - dateB
  })
  return sortedChildren
}

export const updateNotificationRuleActions = (existingNotificationRule, notificationRuleAction) => {
  if (!existingNotificationRule.find(d => d === notificationRuleAction)) {
    existingNotificationRule.push(notificationRuleAction)
  }
  return existingNotificationRule
}

export const isParameterIsBase64 = (str) => {
  try {
    try {
      str = decodeURIComponent(str)
    } catch (e) {
      return false // If URL decoding fails, it's not a valid Base64
    }
    // Check if the length is a multiple of 4
    if (str.length % 4 !== 0) return false
    // Check if it contains only valid Base64 characters
    if (!/^[A-Za-z0-9+/]+={0,2}$/.test(str)) return false
    return true
  } catch (e) {
    return false
  }
}
export const convertBase64ParamsToObject = (queryParam) => {
  if (!isEmpty(queryParam)) {
    if (isParameterIsBase64(queryParam)) {
      let newQueryParam = ""
      try {
        newQueryParam = b64Decode(queryParam)
        if (newQueryParam.includes("detail") && newQueryParam.includes("toPage")) {
          newQueryParam = JSON.parse(newQueryParam)
          newQueryParam.isGima = true
          newQueryParam.systemCode = "DSP"
          newQueryParam = JSON.stringify(newQueryParam)
        }
      } catch (error) {
        newQueryParam = "{}"
      }
      return newQueryParam
    }
  }
  return queryParam
}

export const checkIsComplete = (initialItem, item, flow) => {
  if (flow === "BUSINESS_WORKFLOW" || flow === "GIMA_WORKFLOW") {
    return (
      initialItem?.isCompleted || item?.status === 'skip' || initialItem?.status === 'completed'
    )
  } else {
    return (
      item?.isCompleted || item?.status === 'skip' || item?.status === 'completed'
    )
  }
}

export const customStylesSelect = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? gima.getThemeColor() || '#6fc055' : state.isFocused ? gima.getThemeColor() || '#6fc055' : 'transparent',
    color: state.isSelected ? 'white' : (state.isFocused ? 'white' : 'inherit'),
    '&:hover': {
      backgroundColor: gima.getThemeColor() || '#6fc055',
      color: "white"
    }
  }),
  control: (base, state) => ({
    ...base,
    '&:focus-within': {
      borderColor: gima.getThemeColor() || '#6fc055',
      boxShadow: '0 0 0.2rem rgba(233, 105, 71, 0.25)'
    }
    // You can also use state.isFocused to conditionally style based on the focus state
  })
}

export const theme_color = gima.getThemeColor() || '#6fc055'
//export const theme_color = "#A24857" // light maroon

export const getSubSystemName = () => localStorage.getItem('SubSystemName') || "Intranet Portal"
export const checkServiceIsLock = (workflowByExtension, selectedFilterType) => {
  let isLock
  if (!isEmpty(selectedFilterType)) {
    isLock = workflowByExtension?.workflowFilter?.find(i => JSON.stringify(i?.extension) === JSON.stringify(selectedFilterType?.value))?.isLock
  }
  return isLock
}

//Handle click event when parent system click button and send post message
export const handleNavBtnClick = (type) => {
  switch (type) {
    case "add":
      document.getElementById("add-btn-navbar")?.click()
      break
    case "save":
      document.getElementById("save-btn-navbar")?.click()
      break
    case "delete":
      document.getElementById("delete-btn-navbar")?.click()
      break
    case "back":
      document.getElementById("back-btn-navbar")?.click()
      break
    case "refresh":
      document.getElementById("refresh-btn-navbar")?.click()
      break
    case "search":
      document.getElementById("search-btn-navbar")?.click()
      break
    default:
      break
  }
}

export const checkWorkflowConfig = (item, workFlowConfig) => { 
  if (workFlowConfig?.checker === true) {
    if (item?.assignedTo?.length === 0) {
      return false
    } else {
      const hasAdminIrms = item?.assignedTo?.some(item => item.assignee.includes(gima.getTokenInfo('username')))
      return !hasAdminIrms
    }
  }
  return false
}

export const flattenData = (nestedData) => {
  const flattened = []

  nestedData.forEach((parent) => {
    // 1. Push the Parent/Header item
    flattened.push({
      ...parent,
      type: 'PARENT',
      isParent: true,
      children: undefined
    })

    // 2. Push the Children
    if (parent.children && Array.isArray(parent.children)) {
      parent.children.forEach((child) => {
        flattened.push({
          ...child,
          type: 'CHILD',
          isParent: false,
          parentId: parent.id // Mapping the parent ID as requested
        })
      })
    }
  })

  return flattened
}
export const nestData = (flattenedData) => {
  const nested = []
  let currentParent = null

  flattenedData.forEach((item) => {
    if (item.isParent) {
      // Create a new parent object and reset its children array
      currentParent = {
        ...item,
        children: []
      }
      nested.push(currentParent)
    } else {
      // If it's a child, push it into the children array of the current active parent
      if (currentParent) {
        currentParent.children.push({ ...item })
      }
    }
  })

  return nested
}

export const decodeHtmlEntities = (str) => {
  if (!str) return ''
  return str
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#039;/g, "'")
}

// Returns true if the mail template should be visible given the current task tag filters.
// Mirrors the isMailValid logic in NewMail so both the list count and the rendered items stay in sync.
export const checkMailValidity = (mailObject, flow, taskTagId) => {
  if (mailObject === "empty" || isEmpty(mailObject?.templateName)) return false
  if (flow !== "BUSINESS_WORKFLOW") return true

  const tagKeys = Object.keys(taskTagId || {}).filter(key => Array.isArray(taskTagId[key]))
  const atLeastOneHave = tagKeys.every(key => taskTagId[key].length === 0)
  if (atLeastOneHave) return true

  return tagKeys.every(key => {
    const taskIds = taskTagId[key]
    if (taskIds.length === 0) return true
    const tabIds = (mailObject?.internalTabs?.find(tab => tab.tabKey === key)?.internalTabIds || []).map(d => d.trim())
    if (isEmpty(tabIds)) return true
    return taskIds.some(id => tabIds.includes(id))
  })
}

// Returns true if the mail template's own taskTagId is compatible with the selected workflow service's taskTagId.
// Rule: every tag key present (non-empty) on the mail must exist on the workflow filter and share at least one id.
// A workflow filter with no taskTagId at all, or a mail with no taskTagId keys, imposes no restriction.
export const isTemplateMatchingWorkflowTags = (mailObject, selectedFilterType) => {
  if (isEmpty(mailObject?.templateName)) return false

  const workflowTagId = selectedFilterType?.taskTagId || {}
  if (isEmpty(workflowTagId)) return true

  const mailTagId = mailObject?.taskTagId || {}
  const mailKeys = Object.keys(mailTagId).filter(key => Array.isArray(mailTagId[key]) && !isEmpty(mailTagId[key]))
  if (isEmpty(mailKeys)) return true

  return mailKeys.every(key => {
    const workflowIds = workflowTagId[key]
    if (!Array.isArray(workflowIds) || isEmpty(workflowIds)) return false
    return mailTagId[key].some(id => workflowIds.includes(id))
  })
}

export const workflowFieldsForTemplates = (item) => {
  const fmt = (date) => (date ? moment(date).format(getDateFormat()) : '')

  const assignTo = (item.assignedTo || [])
    .flatMap(a => a.assignee || [])
    .join(', ')

  const tags = (item.tag || [])
    .flat()
    .join(', ')

  const attachDocs = (item.uploadedDocs || [])
    .map(d => d.documentsName)
    .join(', ')

  let status = 'Pending'
  if (item.skip_by) status = 'Skipped'
  else if (item.isCompleted) status = 'Completed'

  return {
    workflow_text: String(item.workflowTitle || ''),
    workflow_task_name: String(item.text || ''),
    workflow_task_details: String(item.detail || ''),
    workflow_task_remark: String(item.remark || ''),
    workflow_task_startDate: fmt(item.startDate),
    workflow_task_endDate: fmt(item.dueDate),
    workflow_task_assignto: assignTo,
    workflow_task_status: status,
    workflow_task_duration: String(item.duration || ''),
    workflow_task_mail: (item.mailTemplateId || []).join(', '),
    workflow_task_compeleteBy: String(item.completed_by || ''),
    workflow_task_completeDate: fmt(item.completedDate),
    workflow_task_skipBy: String(item.skip_by || ''),
    workflow_task_skipDate: fmt(item.skipDate),
    workflow_task_attachDocument: attachDocs,
    workflow_task_tag: tags,
  }
}